import * as React from "react";
import {
  ColumnHelper,
  DisplayColumnDef,
  RowData
} from "@tanstack/react-table";

import { Text } from "src/library/components/Text";
import {
  ITerminology,
  sentenceCase
} from "src/library/utils";
import { IOrder } from "src/core/orders/api/orders.api";

/**
 * This function returns a reusable formated column definition for product count to be used in Tanstack tables
 *
 * @param columnHelper
 * @param accessor
 * @param column
 * @returns column product count data
 */
export const productCountColumn = <TData extends RowData>(
  columnHelper: ColumnHelper<TData>,
  terminology: ITerminology
) => {
  return columnHelper.display({
    id: "productCount",
    header: sentenceCase(terminology.product.plural.text),
    cell: info => {
      const order = info.row.original as IOrder;
      let count = 0;

      order.orderLines.map(orderLine => {
        if (!orderLine.substituteOrderLineId) {
          count += orderLine.quantity;
        }
      });

      return (
        <Text>
          {count}
        </Text>
      );
    },
    enableSorting: false,
    minSize: 70,
    meta: { style: { align: "right" } }
  } as DisplayColumnDef<TData>);
};
